import { Component, Input, OnInit } from '@angular/core';
import { MessageService, LazyLoadEvent } from 'primeng/api';
import { AppDataService, ProductService } from 'app/services';
import { TableLazyLoadEvent } from 'primeng/table';

enum MenuTab {
    ActiveProducts = 1,
    InactiveProducts = 2
}

@Component({
    selector: 'partner-mart-locations-inventory-grid',
    templateUrl: './partner-mart-locations-inventory-grid.component.html',
    styleUrls: ['./partner-mart-locations-inventory-grid.component.scss'],
    providers: [MessageService]
})
export class PartnerMartLocationsInventoryGridComponent implements OnInit {
    @Input()
    public storeId: number = 0;

    @Input()
    public store: any;

    @Input()
    public merchantId: number = 0;

    @Input()
    public groupId: number = 0;

    public menuTab = MenuTab;
    public activeMenuTab: MenuTab = MenuTab.ActiveProducts;

    private timer: number = 0;

    public searchProduct: string = '';

    public loading: boolean = false;

    public storeProducts: any[] = [];

    // Grid settings
    public cols: any[] = [
        { field: 'Id', header: 'Product ID', width: '20%' },
        { field: 'Name', header: 'Product Name', width: '20%' },
        { field: 'UOM', header: 'UOM', width: '20%' },
        { field: 'Units', header: 'RRP', width: '20%' },
        { field: 'DefaultAmount', header: 'Daily Inventory', width: '20%' },
        { field: 'SupplierName', header: 'Supplier', width: '20%' },
        { field: 'IsEnable', header: 'Published Status', width: '20%' },
    ];

    public rowsPerPage: number = 50;
    public rowsPerPageOptions: Array<number> = [50, 100, 500, 1000];
    public totalRecords: number = -1;

    public first: number = 0;
    public sortField: string | string[] = '';
    private sortOrder: number = 1;

    //------------------Edit Product---------------------
    public showMerchantEditProductSideBar: boolean = false;
    public showMerchantDetailProductSideBar: boolean = false;
    public productId: number = 0;
    //-------------------------------------------------------------

    constructor(
        private messageService: MessageService,
        private appData: AppDataService,
        private productService: ProductService) {
    }

    ngOnInit(): void {
    }

    public changeActiveMenuTab(menuTab: MenuTab) {
        this.activeMenuTab = menuTab;
        this.getProductsByStore(0);
    }

    public handleSearchFilterChange(): void {
        if (this.timer) {
            window.clearTimeout(this.timer);
        }

        this.timer = window.setTimeout(() => {
            this.getProductsByStore(0);
            this.timer = 0;
        }, 1500);
    }

    public switchProduct(product: any) {
        this.updateProductIsEnable(product.Id);
    }

    public handleLazyLoad(event: TableLazyLoadEvent): void {
        const skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortField = 'Id';
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        this.getProductsByStore(skip);
    }

    public getProductsByStore(skip: number) {
        const dto = {
            MerchantId: this.store.MerchantId,
            StoreId: this.storeId,
            GroupId: this.groupId,
            IsEnable: (this.activeMenuTab === MenuTab.ActiveProducts) ? true : false,
            Skip: skip,
            SearchName: this.searchProduct,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder
        };

        this.productService.getProductsByStore(dto, this.messageService)
            .then(data => {
                this.loading = false;

                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.first = skip;
                this.totalRecords = data.TotalRecords;

                this.storeProducts = data.Items;
                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    private updateProductIsEnable(productId: number) {
        const dto = {
            MerchantId: this.store.MerchantId,
            ProductId: productId
        };

        this.productService.updateProductIsEnable(dto, this.messageService)
            .then(data => {
                this.loading = false;

                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Data updated successfully' });
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public openMerchantEditProductSideBar(productId: number) {
        this.productId = productId;
        this.showMerchantEditProductSideBar = !this.showMerchantEditProductSideBar;
    }
    changedShowMerchantEditProductSideBarEmit(value: any) {
        this.showMerchantEditProductSideBar = value.visible;

        if (value.productIsEdited) {
            this.getProductsByStore(0);
        }
    }
}
